export default __webpack_public_path__ + "static/media/logo_pmg.f1d3ae79.png";